/**
 * Maps a legacy toast "type" string onto a toast v2 method.
 *
 * Toast v1 (sonner and the `~/utils/toastConfig` wrapper) accepted a free-form type —
 * either as `toast[type](...)` or as `toast(message, { type })`. Toast v2 has no bare
 * callable and a fixed method set, so the type has to be resolved to a method instead.
 *
 * Used by the deferred-toast queue drained in AdminLayout / LearnersPortalLayout and by
 * server-side (Rails flash) toasts, which both carry Rails-style names such as `alert`
 * and `notice`.
 */
const TYPE_TO_METHOD = {
  success: 'success',
  error: 'critical',
  alert: 'critical',
  critical: 'critical',
  danger: 'critical',
  warning: 'warning',
  warn: 'warning',
  info: 'info',
  notice: 'info',
  message: 'info',
}

export const toastV2MethodForType = type => TYPE_TO_METHOD[type] || 'info'

/**
 * Fires `message` on `toast` (a `useToastV2()` instance) using the method that matches
 * `type`. Returns the toast id, or undefined when there is nothing to show.
 */
export const fireTypedToastV2 = (toast, type, message, options = { showCloseButton: false }) => {
  if (!message) return undefined
  const method = toastV2MethodForType(type)
  return toast[method](message, options)
}
